module.exports = "pegasus/assets/blocks/column-12-theme4.png";